import { gql } from '@apollo/client';

export const UPDATE_CLASS_OBJECTIVE = gql`
  mutation UpdateClasseObjective($name: String!, $ca: Int!) {
    updateClassObjective(name: $name, ca: $ca) {
      objectif {
        name
        ca
      }
    }
  }
`;
